import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'

export const InputFormAgent: {
    input?: InputBuildProps
    select?: SelectBuildProps
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'codigo',
            label: 'Código do DETRAN',
            required: true,
            maxLength: 12
        },
        layout: {
            type: 'col',
            layout: { base: 8 }
        }
    },
    {
        select: {
            id: 'uf',
            label: 'UF',
            required: true,
            optionsType: 'uf'
        },
        layout: {
            type: 'col',
            layout: { base: 4 }
        }
    }
]
